import React from 'react';
import { changePassword } from 'meteor-apollo-accounts';
import styled from 'styled-components';
// APOLLO
import ApolloClient from 'ApolloClient';
// COMPONENTS
import UserForm from 'components/forms/UserForm';
import ChangePasswordForm from 'components/forms/ChangePasswordForm';
import message from 'antd/lib/message';
import PageContainer from 'components/common/PageContainer';
import SectionHeader from 'components/text/SectionHeader';
//
import saveUserAccount from 'ApolloClient/Mutations/saveUserAccount';
import { graphql } from 'react-apollo';
import Card from 'antd/lib/card';

const ContentContainer = styled.div`
  align-items: center;
  justify-content: center;
  width: 500px;
  max-width: 100%;
  margin-top: 55px;
`;

class AppAccount extends React.Component {
  state = {
    loading: false,
  };

  postMutationUpdate = (proxy, { data }) => {
    // TODO: post mutation update
  };

  handleSaveAccountSubmit = async values => {
    this.setState({ loading: true });
    let variables = {
      _id: this.props.currentUser._id,
      params: {
        ...values,
      },
    };
    try {
      await this.props.saveUserAccount({ variables });
      message.success('Profile saved!');
    } catch (err) {
      console.log(err);
    }
    this.setState({ loading: false });
  };

  handleChangePasswordSubmit = async ({ oldPassword, newPassword }) => {
    this.setState({ loading: true });
    try {
      await changePassword({ oldPassword, newPassword }, ApolloClient);
      message.success('New password saved!');
    } catch (err) {
      // console.log('err', Object.keys(err));
      console.log('err', err);
      message.error(err.message || 'Something went wrong');
    }
    this.setState({ loading: false });
  };

  render() {
    return (
      <PageContainer>
        <React.Fragment>
          <ContentContainer>
            <SectionHeader>Profile Details</SectionHeader>
            <Card bodyStyle={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <UserForm
                user={this.props.currentUser}
                loading={this.state.loading}
                handleSubmit={this.handleSaveAccountSubmit}
              />
            </Card>
          </ContentContainer>
          <ContentContainer>
            <SectionHeader>Change Password</SectionHeader>
            <Card bodyStyle={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <ChangePasswordForm loading={this.state.loading} handleSubmit={this.handleChangePasswordSubmit} />
            </Card>
          </ContentContainer>
        </React.Fragment>
      </PageContainer>
    );
  }
}

export default graphql(saveUserAccount, { name: 'saveUserAccount' })(AppAccount);



// WEBPACK FOOTER //
// ./src/routes/app-account/index.js